module.exports = __webpack_public_path__ + "static/media/ODS7.0d5cc7da.svg";